import { Link } from "react-router-dom";

interface BrandLogoProps {
  size?: "sm" | "md" | "lg";
  onClick?: () => void;
}

const sizeClasses = {
  sm: { elara: "text-3xl", health: "text-[0.75rem]" },
  md: { elara: "text-4xl md:text-5xl", health: "text-[0.9rem] md:text-[1.1rem]" },
  lg: { elara: "text-4xl md:text-5xl", health: "text-[0.9rem] md:text-[1.1rem]" },
};

const BrandLogo = ({ size = "md", onClick }: BrandLogoProps) => {
  return (
    <Link
      to="/"
      onClick={onClick}
      className="inline-flex flex-col leading-tight w-fit"
      aria-label="Elara Health"
    >
      <span aria-hidden="true" className={`font-display ${sizeClasses[size].elara} tracking-wide text-foreground`}>
        ELARA
      </span>
      <span
        aria-hidden="true"
        className={`-mt-1 flex justify-between w-full ${sizeClasses[size].health} font-semibold uppercase text-champagne`}
      >
        {"HEALTH".split("").map((ch, i) => (
          <span key={i}>{ch}</span>
        ))}
      </span>
    </Link>
  );
};

export default BrandLogo;
